module.exports = __webpack_public_path__ + "static/media/amazon.9bb632dc.svg";